<template>
  <!-- <div class="mt-2 card">
    <h3 class="font-grey kne-title">{{$t('Dashboard.update.title')}}</h3>
    <div class="w-100 container pb-2">
      <div v-for="(update, index) in updateList.transporter" :key="index" class="m-2 mb-5 w-100 update-container">
        <h3>{{update.title}}</h3>
        <span class="devNote"><i>{{$t('Dashboard.update.dev-notes')}}: "{{update.devNote}}"</i></span>
        <span class="devNote update-dateText mt-3"><i>{{formatDate(update.creationDate)}}</i></span>
        <hr class="hrLine mt-0 w-100">
        <span>{{update.description[getLanguage]}}</span>
      </div>
    </div>
  </div> -->
  <div class="mt-2 card">
    <h3 class="font-grey kne-title">{{$t('Dashboard.update.title')}}</h3>
    <paginate-links for="updatesList" :hide-single-page="true" :limit="5"></paginate-links>
    <paginate name="updatesList" tag="div" :list="updatesList" class="" :per="12">
      <transition-group name="fade" tag="div">

        <div v-for="note in paginated('updatesList')" class="card-block p-3 pb-4 message update-item"
          data-toggle="collapse" data-parent="#accordion" :href="'#collapse' + note['.key']" aria-expanded="true"
          :aria-controls="'#collapse' + note['.key']" :key="note['.key']"
          :class="{ 'new-update': !updatesRead.some(item => item['.value'] === note['.key']) }">
          <div class="accordion-header" @click="readUpdate(note['.key'])">
            <div class="header font-grey d-flex justify-content-between">
              <div class="d-flex flex-column justify-content-between">
                <i>{{ $store.state.i18n.locale === 'en'
                  ? note.title.en
                  : note.title.fr }}</i>
                <div class="pull-right small">{{ formatDate(note.creationDate) }}</div>
              </div>
              <i v-if="openAccordions.includes(note['.key'])" class="fas fa-chevron-up"></i>
              <i v-else class="fas fa-chevron-down"></i>
            </div>
          </div>
          <div :id="'collapse' + note['.key']" class="collapse accordion-body-custom" role="tabpanel"
            aria-labelledby="headingOne">
            <p class="text-justify" v-html="sanitizeDescription(note)" @click.stop></p>
          </div>
        </div>
      </transition-group>
    </paginate>
  </div>
</template>

<script>
import { db } from '../../../../firebase.js'
import DOMPurify from 'dompurify'
/** Update list to show for users. Viewable in Dashboard. */
export default {
  data () {
    return {
      updateList: [],
      updatesList: [],
      // notes: [],
      updates: [],
      paginate: ['updatesList'],
      updatesRead: [],
      openAccordions: []
    }
  },

  async created () {
    // this.$bindAsArray('notes', db.ref('database/transporter').child(this.companyUID).child('notes'), null, () => {
    // })
    this.$bindAsArray('updates', db.ref('updates').child('transporter'), null, () => {
    })
    await this.$bindAsArray('updatesRead', db.ref('database/transporter').child(this.companyUID).child('user').child('employees').child(this.uid).child('infos').child('updatesRead'), null, () => {
      this.updateSeenUpdates()
    })
    await this.loadNewUpdateList()
    .catch(error => {
      console.error('Error getting updatesRead length:', error)
    })
  },

  methods: {
    sanitizeDescription (note) {
      const description = this.$store.state.i18n.locale === 'en'
        ? note.description.en
        : note.description.fr
      return DOMPurify.sanitize(description, {
        ADD_ATTR: ['target']
      })
    },
    async updateSeenUpdates () {
      const isSeen = this.updates.length === this.updatesRead.length
      await this.$store.dispatch('updateActiveCompanySeen', isSeen)
    },
    readUpdate (pid) {
      this.toggleAccordion(pid)

      const updatesReadRef = db.ref('/database/transporter')
        .child(this.companyUID)
        .child('user')
        .child('employees')
        .child(this.uid)
        .child('infos')
        .child('updatesRead')

      updatesReadRef.once('value')
        .then(snapshot => {
          let updatesReadArray = snapshot.val() || []
          if (!updatesReadArray.includes(pid)) {
            updatesReadArray.push(pid)
          }

          updatesReadRef.set(updatesReadArray)
            .then(() => {
              this.updateSeenUpdates()
            })
            .catch(error => {
              console.error('Error updating data:', error)
            })
        })
        .catch(error => {
          console.error('Error fetching updatesRead data:', error)
        })
    },
    toggleAccordion (pid) {
      const index = this.openAccordions.indexOf(pid)
      if (index > -1) {
        this.openAccordions.splice(index, 1)
      } else {
        this.openAccordions.push(pid)
      }
    },
    async loadNewUpdateList () {
     await db.ref().child('updates').child('transporter').once('value').then((data) => {
      this.updateList[data.key] = data.val()
     })
    },
    getDate: function (timestamp) {
      var date = new Date(timestamp)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    },
    formatDate (date) {
      var formattedDate = new Date(date)
      return formattedDate.getFullYear() + '-' + ('0' + (formattedDate.getMonth() + 1)).slice(-2) + '-' + ('0' + formattedDate.getUTCDate()).slice(-2)
    }
  },

  computed: {
    getLanguage () {
      return this.$store.state.userInfo.language
    },
    companyUID () {
      return this.$store.state.authorization.company
    },
    uid () {
      return this.$store.state.user.uid
    }
  },

  watch: {
    // notes: function (snapshot) {
    //   this.updatesList = JSON.parse(JSON.stringify(snapshot))
    //   this.updatesList.reverse()
    // }
    updates: function (snapshot) {
      this.updatesList = JSON.parse(JSON.stringify(snapshot))
    }
  }
}
</script>

<style scoped>
  .update-container {
    display: flex;
    flex-flow: column;
  }
  .devNote {
    color: rgb(70, 70, 70);
  }
  .update-dateText {
    font-size: 0.8rem;
  }
  .hrLine {
    border: 1px rgba(172, 172, 172, 0.386) solid;
  }
  .description {
    background-color: rgb(222, 222, 222);
  }
  h1, h2 {
    font-weight: normal;
    text-align: center;
  }
  @media (max-width: 767px) {
    .btn {
      margin-top: .5rem
    }
  }
  /* #notes{
    overflow-wrap: break-word;
  } */
   .update-item{
    transition: background-color 2s ease;
   }
   .new-update{
    background-color: #86efac;
    transition: background-color 2s ease;
   }
   .accordion-body-custom{
    padding-top:1rem !important;
   }
</style>
